import React from 'react';
import styles from './Nav.module.css';

const Nav = () => {
     return <div className={styles.container}></div>;
};

export default Nav;
